import React, { useMemo, useState } from 'react';

export const LiveVetContext = React.createContext();

const Provider = ({ children }) => {
  const [callbackPetParent, setCallbackParnt] = useState({});
  const [callbackNewCustomer, setCallbackNewCustomer] = useState({});

  const petParentValue = useMemo(() => ({
    forcePetParentValidation: () => {
      if (callbackPetParent
        && callbackPetParent.forcePetParentValidation) {
        callbackPetParent.forcePetParentValidation();
      }
    },
    setForcePetParent: (callback) => {
      setCallbackParnt({ forcePetParentValidation: callback });
    },
  }), [callbackPetParent]);

  const newCustomerValue = useMemo(() => ({
    forceNewCustomerValidation: () => {
      if (callbackNewCustomer
        && callbackNewCustomer.forceNewCustomerValidation) {
        callbackNewCustomer.forceNewCustomerValidation();
      }
    },
    setForceNewCustomer: (callback) => {
      setCallbackNewCustomer({ forceNewCustomerValidation: callback });
    },
  }), [callbackNewCustomer]);

  const providerValue = useMemo(() => ({
    newCustomerValue, petParentValue,
  }), [newCustomerValue, petParentValue]);

  return (
    <LiveVetContext.Provider value={providerValue}>
      {children}
    </LiveVetContext.Provider>
  );
};

export default { Consumer: LiveVetContext.Consumer, Provider };
